import { Box } from '@mui/material';
import { upperFirst } from 'lodash';

import { ToggleButtonGroupField } from '@occc-app/design-system';

import { MESSAGE_INTENTS } from '../../triggered-messages.constants';

export const MessageIntentConfigurator = () => {
  return (
    <Box>
      <ToggleButtonGroupField
        name='messageIntent'
        label='Message Intent'
        buttons={MESSAGE_INTENTS.map((intent) => ({
          title: upperFirst(intent.toLowerCase()),
          value: intent,
        }))}
        fullWidth
      />
    </Box>
  );
};
